import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_140_add_purchase_with_order: any[] = [
    {
        "componentType": "screenGroup",
        "title": "Purchase with order",
        "style": {},
        "childComponents": [
            {
                "componentType": "form",
                "Name": "pur_add",
                "TableName": "purchase",
                "Plugins": [
                    {
                        "type": "api",
                        "module": "all"
                    }
                ],
                "columnNumber": "m1 t1 w1",
                "style": {
                    "padding": 10,
                    "backgroundColor": "#ffffff",
                    "direction": "column"
                },
                "Fields": [
                    {
                        "componentType": "fieldGroup",
                        "Label": "Purchase details",
                        "BindValue": "con_purchase_details",
                        "style": {
                            "direction": "column"
                        },
                        "childComponents": [
                            {
                                "componentType": "searchableDropdown",
                                "name": "drp_purchase",
                                "label": "Purchase order No.",
                                "placeholder": "",
                                "required": false,
                                "lookupName": "purchare_order",
                                "options": [],
                                "searchable": true,
                                "clearable": true,
                                "Json_Attribute": "purchase_order_id",
                                "BindValue": "drp_purchase"
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_purchaseno",
                                "label": "Purchase No.",
                                "placeholder": "Will be auto generated...",
                                "required": false,
                                "inputType": "text",
                                "disabled": true,
                                "Json_Attribute": "purchase_no",
                                "BindValue": "txt_purchaseno",
                                "AutoPopulate": true,
                                "AutoPopulate_format": "PUR_[******]"
                            },
                            {
                                "componentType": "dateField",
                                "name": "txt_Purchase_date",
                                "label": "Purchase date",
                                "placeholder": "",
                                "required": true,
                                "Json_Attribute": "purchase_date",
                                "BindValue": "txt_Purchase_date",
                                "DefaultToday": true,
                                "validation": [
                                    {
                                        "rule": "required",
                                        "message": "Purchase date is required"
                                    }
                                ]
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_mobile",
                                "label": "Mobile",
                                "placeholder": "",
                                "required": false,
                                "inputType": "phone",
                                "disabled": false,
                                "Json_Attribute": "mobile_no",
                                "BindValue": "txt_mobile",
                                "BindParent": {
                                    "drp_purchase": "mobile_no"
                                }
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_trn",
                                "label": "TRN.",
                                "placeholder": "",
                                "required": false,
                                "inputType": "text",
                                "disabled": true,
                                "Json_Attribute": "vendor_taxregno",
                                "BindValue": "txt_trn",
                                "BindParent": {
                                    "drp_purchase": "taxregno"
                                }
                            },
                            {
                                "componentType": "textField",
                                "name": "sup_name",
                                "label": "Vendor name",
                                "placeholder": "",
                                "required": false,
                                "inputType": "text",
                                "disabled": true,
                                "Json_Attribute": "",
                                "BindValue": "sup_name",
                                "BindParent": {
                                    "drp_purchase": "sname"
                                }
                            },
                            {
                                "componentType": "checkbox",
                                "name": "is_cash",
                                "label": "Cash purchase",
                                "placeholder": "",
                                "required": false,
                                "inputType": "text",
                                "Json_Attribute": "is_cash",
                                "BindValue": "is_cash",
                                "defaultValue": "False"
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_vendor_refno",
                                "label": "Vendor Ref No.",
                                "placeholder": "",
                                "required": false,
                                "inputType": "text",
                                "BindValue": "txt_vendor_refno",
                                "Json_Attribute": "vendor_refno"
                            },
                            {
                                "componentType": "dateField",
                                "name": "txt_Purchase_ref_date",
                                "label": "Ref date",
                                "placeholder": "",
                                "DefaultToday": true,
                                "required": false,
                                "BindValue": "txt_Purchase_ref_date",
                                "Json_Attribute": "ref_date"
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_credit_days",
                                "label": "Credit days",
                                "placeholder": "",
                                "required": false,
                                "inputType": "number",
                                "defaultValue": "0",
                                "Json_Attribute": "credit_days",
                                "BindValue": "txt_credit_days",
                                "BindParent": {
                                    "drp_purchase": "term"
                                },
                                "validation": [
                                    {
                                        "rule": "pattern",
                                        "value": "^[0-9]*$",
                                        "message": "Only whole numbers are allowed"
                                    }
                                ]
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_billingaddress",
                                "label": "Address",
                                "placeholder": "",
                                "required": false,
                                "inputType": "text",
                                "disabled": true,
                                "Json_Attribute": "billing_address",
                                "BindValue": "txt_billingaddress",
                                "BindParent": {
                                    "drp_purchase": "billing_address"
                                }
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_remarks",
                                "label": "Remarks",
                                "placeholder": "",
                                "required": false,
                                "inputType": "text",
                                "BindValue": "txt_remarks",
                                "Json_Attribute": "remarks"
                            },
                            {
                                "componentType": "dateField",
                                "name": "txt_due_date",
                                "label": "Due date",
                                "placeholder": "",
                                "required": true,
                                "Json_Attribute": "due_date",
                                "BindValue": "txt_due_date",
                                "ComputeDueDate": {
                                    "purchaseDateField": "txt_Purchase_date",
                                    "creditDaysField": "txt_credit_days"
                                }
                            }
                        ]
                    },
                    {
                        "componentType": "subModule",
                        "name": "purchase_details",
                        "label": "Purchase details",
                        "tableName": "purchase_details",
                        "lookupName": "purchase_order_details",
                        "parentField": "drp_purchase",
                        "BindValue": "jobcard_details",
                        "enableAddAction": false,
                        "allowAdd": false,
                        "childControls": [
                            {
                                "componentType": "searchableDropdown",
                                "name": "job_card_id_item",
                                "label": "Jobcard No.",
                                "placeholder": "",
                                "required": false,
                                "lookupName": "parts_issue_jobcard_purchase",
                                "options": [],
                                "searchable": true,
                                "clearable": true,
                                "Json_Attribute": "job_card_id",
                                "BindValue": "job_card_id_item"
                            },
                            {
                                "componentType": "searchableDropdown",
                                "name": "drp_product",
                                "label": "Code",
                                "placeholder": "",
                                "required": false,
                                "lookupName": "product_itemcode",
                                "options": [],
                                "searchable": true,
                                "clearable": true,
                                "Json_Attribute": "product_id",
                                "BindValue": "drp_product"
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_itemname",
                                "label": "Item name",
                                "placeholder": "",
                                "required": false,
                                "inputType": "text",
                                "Json_Attribute": "item_name",
                                "disabled": true,
                                "BindValue": "txt_itemname",
                                "BindParent": {
                                    "drp_product": "item_name"
                                }
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_rate",
                                "label": "Rate",
                                "placeholder": "",
                                "required": false,
                                "inputType": "number",
                                "defaultValue": "0",
                                "Json_Attribute": "rate",
                                "disabled": false,
                                "BindValue": "txt_rate",
                                "ExpressionV2": "[drp_product.purchase_rate]"
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_qty",
                                "label": "Qty",
                                "placeholder": "",
                                "required": false,
                                "inputType": "number",
                                "defaultValue": "0",
                                "Json_Attribute": "qty",
                                "disabled": true,
                                "BindValue": "txt_qty",
                                "validation": [
                                    {
                                        "rule": "custom",
                                        "message": "The quantity should be greater than 0",
                                        "condition": "[txt_qty] > 0"
                                    }
                                ]
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_unit_discount",
                                "label": "Unit discount",
                                "placeholder": "",
                                "required": false,
                                "inputType": "number",
                                "defaultValue": "0",
                                "Json_Attribute": "unit_discount",
                                "disabled": false,
                                "BindValue": "txt_unit_discount"
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_line_discount",
                                "label": "Total discount",
                                "placeholder": "",
                                "required": false,
                                "inputType": "number",
                                "defaultValue": "0",
                                "Json_Attribute": "line_discount",
                                "disabled": true,
                                "BindValue": "txt_line_discount",
                                "ExpressionV2": "[txt_unit_discount] * [txt_qty]"
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_amount",
                                "label": "Amount",
                                "placeholder": "",
                                "required": false,
                                "inputType": "number",
                                "defaultValue": "0",
                                "Json_Attribute": "amount",
                                "disabled": true,
                                "BindValue": "txt_amount",
                                "ExpressionV2": "[txt_rate] * [txt_qty]"
                            },
                            {
                                "componentType": "selectDropdown",
                                "name": "drp_vat",
                                "label": "VAT%",
                                "placeholder": "",
                                "required": false,
                                "lookupName": "tax_rates",
                                "options": [],
                                "defaultValue": "5%",
                                "Json_Attribute": "vat_id",
                                "BindValue": "drp_vat"
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_vat_amt",
                                "label": "VAT amount",
                                "placeholder": "",
                                "required": false,
                                "inputType": "number",
                                "defaultValue": "0",
                                "Json_Attribute": "vat_amt",
                                "disabled": true,
                                "BindValue": "txt_vat_amt",
                                "ExpressionV2": "([txt_amount] - [txt_line_discount]) * ([drp_vat.taxrate]/100)"
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_net_amt",
                                "label": "Net amount",
                                "placeholder": "",
                                "required": false,
                                "inputType": "number",
                                "defaultValue": "0",
                                "Json_Attribute": "net_amt",
                                "disabled": true,
                                "BindValue": "txt_net_amt",
                                "ExpressionV2": "([txt_amount] - [txt_line_discount]) + [txt_vat_amt]"
                            }
                        ],
                        "FooterControls": [
                            {
                                "componentType": "textField",
                                "BindValue": "txt_one",
                                "IncludeLabel": false,
                                "IsReadOnly": true,
                                "style": {
                                    "display": "none"
                                }
                            },
                            {
                                "componentType": "textField",
                                "BindValue": "txt_2",
                                "IncludeLabel": false,
                                "IsReadOnly": true,
                                "style": {
                                    "display": "none"
                                }
                            },
                            {
                                "componentType": "textField",
                                "BindValue": "txt_3",
                                "IncludeLabel": false,
                                "IsReadOnly": true,
                                "style": {
                                    "display": "none"
                                }
                            },
                            {
                                "componentType": "textField",
                                "BindValue": "txt_4",
                                "IncludeLabel": false,
                                "IsReadOnly": true,
                                "style": {
                                    "display": "none"
                                }
                            },
                            {
                                "componentType": "textField",
                                "BindValue": "txt_6",
                                "IncludeLabel": false,
                                "IsReadOnly": true,
                                "style": {
                                    "display": "none"
                                }
                            },
                            {
                                "IncludeLabel": false,
                                "Label": "Amount",
                                "PlaceHolder": "",
                                "IsMandatory": false,
                                "BindValue": "txt_sub_amount",
                                "Json_Attribute": "amount",
                                "componentType": "textField",
                                "showInSummary": false,
                                "IsReadOnly": true,
                                "ExpressionV2": "[SUM:txt_amount]",
                                "IsVerticalView": true,
                                "inputType": "number",
                                "Default_Value": "0"
                            },
                            {
                                "IncludeLabel": false,
                                "Label": "Total discount",
                                "PlaceHolder": "",
                                "IsMandatory": false,
                                "BindValue": "purchase_line_discount_total",
                                "Json_Attribute": "line_discount_total",
                                "componentType": "textField",
                                "showInSummary": false,
                                "IsReadOnly": true,
                                "ExpressionV2": "[SUM:txt_line_discount]",
                                "IsVerticalView": true,
                                "inputType": "number",
                                "Default_Value": "0"
                            },
                            {
                                "IncludeLabel": false,
                                "Label": "VAT amount",
                                "PlaceHolder": "",
                                "IsMandatory": false,
                                "BindValue": "spare_vat_amount",
                                "Json_Attribute": "vat_amount",
                                "componentType": "textField",
                                "showInSummary": false,
                                "IsReadOnly": true,
                                "ExpressionV2": "[SUM:txt_vat_amt]",
                                "IsVerticalView": true,
                                "inputType": "number",
                                "Default_Value": "0"
                            },
                            {
                                "IncludeLabel": true,
                                "Label": "Round off",
                                "PlaceHolder": "",
                                "IsMandatory": false,
                                "BindValue": "txt_round_off",
                                "Json_Attribute": "round_off_amt",
                                "componentType": "textField",
                                "showInSummary": false,
                                "IsReadOnly": false,
                                "disabled": false,
                                "IsVerticalView": true,
                                "inputType": "number",
                                "AllowNegative": true,
                                "Default_Value": "0",
                                "ForceExpressionUpdate": true
                            },
                            {
                                "IncludeLabel": false,
                                "Label": "Net amount",
                                "PlaceHolder": "",
                                "IsMandatory": false,
                                "BindValue": "txt_sub_net_amount",
                                "Json_Attribute": "net_amount",
                                "componentType": "textField",
                                "showInSummary": false,
                                "IsReadOnly": true,
                                "ExpressionV2": "[SUM:txt_net_amt] - [txt_round_off]",
                                "IsVerticalView": true,
                                "inputType": "number",
                                "Default_Value": "0"
                            }
                        ]
                    }
                ]
            },
            {
                "componentType": "button",
                "name": "Submit",
                "onPressAction": "save",
                "style": {
                    "backgroundColor": "#22c55e"
                }
            }
        ]
    }
];

